import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { EthnicityValue } from 'types/enums';

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<unknown, string>) =>
      filterItem.operator.toLocaleLowerCase() === params.value.toLocaleLowerCase();
  },
  InputComponentProps: { type: 'string' },
});

export const getPatientEthnicityFilters = (): GridFilterOperator[] => {
  return Object.values(EthnicityValue).map((value) => {
    return {
      label: value,
      value: value,
      ...getFilterParams(),
    };
  });
};
